// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__tDiyz","paramInput":"JobSimulator_paramInput__FnlyJ","input":"JobSimulator_input__1-5Fw"};